<template>
  <div class="container">
    <h3 class="green subtitle">
      {{ $translate('subtitle_form_model_allestimento') }}
    </h3>
    <hr />

    <div class="container">
      <div class="columns">
        <div class="column">
          <b-field
            :type="{ 'is-danger': errors.has('typecontr') }"
            :message="errors.first('typecontr')"
            :label="$translate('typecontr') | capitalize"
          >
            <b-select
              v-model="mod.typecontr"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="typecontr"
            >
              <option v-for="optio in $contrafforte" :key="optio.key" :value="optio.key">{{
                $translate(optio.key) | capitalize
              }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field
            :type="{ 'is-danger': errors.has('contrmat') }"
            :label="$translate('contrmat') | capitalize"
            :message="errors.first('contrmat')"
          >
            <b-select
              v-model="mod.contrmat"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="contrmat"
              @input="changepell1"
            >
              <option
                v-for="optio in availablecont"
                :key="optio.id"
                :value="optio.id"
                :label="$translateMaterial(optio)"
                >{{ $translateMaterial(optio) }}</option
              >
            </b-select>
          </b-field>
          <b-field
            v-show="mod.contrmat != null"
            :message="errors.first('contrvar')"
            :type="{ 'is-danger': errors.has('contrvar') }"
            :label="$translate('contrvar') | capitalize"
          >
            <b-select
              v-model="mod.contrvar"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="contrvar"
              @input="changeImage1"
            >
              <template v-for="optio in availablecont">
                <template v-if="optio.id == mod.contrmat">
                  <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">{{
                    $translateMaterialVariant(variant)
                  }}</option>
                </template>
              </template>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <img
            :src="image1 == null ? 'https://place-hold.it/100x100' : image1"
            style="max-width: 100px; max-height: 100px;"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            :type="{ 'is-danger': errors.has('typesott') }"
            :message="errors.first('typesott')"
            :label="$translate('typesott') | capitalize"
          >
            <b-select
              v-model="mod.typesott"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="typesott"
            >
              <option v-for="optio in $sottopiede" :key="optio.key" :value="optio.key">{{
                $translate(optio.key) | capitalize
              }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field
            :type="{ 'is-danger': errors.has('sottmat') }"
            :label="$translate('sottmat') | capitalize"
            :message="errors.first('sottmat')"
          >
            <b-select
              v-model="mod.sottmat"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="sottmat"
              @input="changepell2"
            >
              <option
                v-for="optio in availablesott"
                :key="optio.id"
                :value="optio.id"
                :label="$translateMaterial(optio)"
                >{{ $translateMaterial(optio) }}</option
              >
            </b-select>
          </b-field>
          <b-field
            v-show="mod.sottmat != null"
            :message="errors.first('sottvar')"
            :type="{ 'is-danger': errors.has('sottvar') }"
            :label="$translate('sottvar') | capitalize"
          >
            <b-select
              v-model="mod.sottvar"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="sottvar"
              @input="changeImage2"
            >
              <template v-for="optio in availablesott">
                <template v-if="optio.id == mod.sottmat">
                  <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">{{
                    $translateMaterialVariant(variant)
                  }}</option>
                </template>
              </template>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <img
            :src="image2 == null ? 'https://place-hold.it/100x100' : image2"
            style="max-width: 100px; max-height: 100px;"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            :type="{ 'is-danger': errors.has('typepun') }"
            :message="errors.first('typepun')"
            :label="$translate('typepun') | capitalize"
          >
            <b-select
              v-model="mod.typepun"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="typepun"
            >
              <option v-for="optio in $puntale" :key="optio.key" :value="optio.key">{{
                $translate(optio.key) | capitalize
              }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field
            :type="{ 'is-danger': errors.has('punmat') }"
            :label="$translate('punmat') | capitalize"
            :message="errors.first('punmat')"
          >
            <b-select
              v-model="mod.punmat"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="punmat"
              @input="changepell3"
            >
              <option
                v-for="optio in availablepunt"
                :key="optio.id"
                :value="optio.id"
                :label="$translateMaterial(optio)"
                >{{ $translateMaterial(optio) }}</option
              >
            </b-select>
          </b-field>
          <b-field
            v-show="mod.punmat != null"
            :message="errors.first('punvar')"
            :type="{ 'is-danger': errors.has('punvar') }"
            :label="$translate('punvar') | capitalize"
          >
            <b-select
              v-model="mod.punvar"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              name="punvar"
              @input="changeImage3"
            >
              <template v-for="optio in availablepunt">
                <template v-if="optio.id == mod.punmat">
                  <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">{{
                    $translateMaterialVariant(variant)
                  }}</option>
                </template>
              </template>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <img
            :src="image3 == null ? 'https://place-hold.it/100x100' : image3"
            style="max-width: 100px; max-height: 100px;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/contrafforte'
import '../../../helpers/mixins/variables/sottopiede'
import '../../../helpers/mixins/variables/puntale'

export default {
  name: 'allestimento',
  data() {
    return {
      image1: null,
      image2: null,
      image3: null,
    }
  },
  props: ['mod', 'availablecont', 'availablesott', 'availablepunt', 'disabledbool'],
  inject: ['$validator'],
  watch: {
    mod: function() {
      this.updateAfterload()
    },
  },
  methods: {
    changepell1() {
      this.mod.contrvar = null
      this.image1 = null
    },
    changepell2() {
      this.mod.sottvar = null
      this.image2 = null
    },
    changepell3() {
      this.mod.punvar = null
      this.image3 = null
    },
    changeImage1() {
      this.image1 = null
      for (let index in this.availablecont) {
        if (this.availablecont[index].id == this.mod.contrmat) {
          for (let index2 in this.availablecont[index].variants) {
            if (this.availablecont[index].variants[index2].id == this.mod.contrvar) {
              this.image1 = this.availablecont[index].variants[index2].image
            }
          }
        }
      }
    },
    changeImage2() {
      this.image2 = null
      for (let index in this.availablesott) {
        if (this.availablesott[index].id == this.mod.sottmat) {
          for (let index2 in this.availablesott[index].variants) {
            if (this.availablesott[index].variants[index2].id == this.mod.sottvar) {
              this.image2 = this.availablesott[index].variants[index2].image
            }
          }
        }
      }
    },
    changeImage3() {
      this.image3 = null
      for (let index in this.availablepunt) {
        if (this.availablepunt[index].id == this.mod.punmat) {
          for (let index2 in this.availablepunt[index].variants) {
            if (this.availablepunt[index].variants[index2].id == this.mod.punvar) {
              this.image3 = this.availablepunt[index].variants[index2].image
            }
          }
        }
      }
    },

    updateAfterload() {
      this.changeImage1()
      this.changeImage2()
      this.changeImage3()
    },
  },
}
</script>
